/* tslint:disable */
/* eslint-disable */
/**
 * Integrations Service
 * Provides an API to integrate with various 3rd party integrations
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AuthMode } from './AuthMode';
import {
    AuthModeFromJSON,
    AuthModeFromJSONTyped,
    AuthModeToJSON,
} from './AuthMode';
import type { ExtraFieldDto } from './ExtraFieldDto';
import {
    ExtraFieldDtoFromJSON,
    ExtraFieldDtoFromJSONTyped,
    ExtraFieldDtoToJSON,
} from './ExtraFieldDto';
import type { ProviderTypes } from './ProviderTypes';
import {
    ProviderTypesFromJSON,
    ProviderTypesFromJSONTyped,
    ProviderTypesToJSON,
} from './ProviderTypes';

/**
 * 
 * @export
 * @interface FindProviderResponse
 */
export interface FindProviderResponse {
    /**
     * 
     * @type {ProviderTypes}
     * @memberof FindProviderResponse
     */
    providerType?: ProviderTypes;
    /**
     * 
     * @type {AuthMode}
     * @memberof FindProviderResponse
     */
    authMode?: AuthMode;
    /**
     * 
     * @type {Array<ExtraFieldDto>}
     * @memberof FindProviderResponse
     */
    extraFields?: Array<ExtraFieldDto>;
}

/**
 * Check if a given object implements the FindProviderResponse interface.
 */
export function instanceOfFindProviderResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindProviderResponseFromJSON(json: any): FindProviderResponse {
    return FindProviderResponseFromJSONTyped(json, false);
}

export function FindProviderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindProviderResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'providerType': !exists(json, 'providerType') ? undefined : ProviderTypesFromJSON(json['providerType']),
        'authMode': !exists(json, 'authMode') ? undefined : AuthModeFromJSON(json['authMode']),
        'extraFields': !exists(json, 'extraFields') ? undefined : ((json['extraFields'] as Array<any>).map(ExtraFieldDtoFromJSON)),
    };
}

export function FindProviderResponseToJSON(value?: FindProviderResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'providerType': ProviderTypesToJSON(value.providerType),
        'authMode': AuthModeToJSON(value.authMode),
        'extraFields': value.extraFields === undefined ? undefined : ((value.extraFields as Array<any>).map(ExtraFieldDtoToJSON)),
    };
}

